import React, {useEffect, useMemo, useState} from 'react';
import CustomTable from '../AlertTableDesignedWithCheckboxes';
import {APP_ALERT_CENTER_API_ENDPOINT} from 'constants/api_urls';
import '../index.scss';
import DmpIcons from "components/DmpIcons/icons";

const GroupListTable = ({ idaccount, jwtToken, onGroupsSelect, rowSelection, setRowSelection, onClose }) => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID', maxSize: 40 },
        { accessorKey: 'name', header: 'Name', maxSize: 220 },
        { accessorKey: 'country', header: 'Country', maxSize: 40 },
    ], []);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await fetch(`${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center/list-groups/${idaccount}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${jwtToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération des données');
                }

                const data = await response.json();
                setGroups(data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };

        fetchGroups();
    }, [idaccount, jwtToken]);

    useEffect(() => {
        const selectedGroups = groups.filter(group => rowSelection[group.id]);
        onGroupsSelect(selectedGroups);
    }, [rowSelection, groups, onGroupsSelect]);

    return (
        <div className="hotel-table-container">
            <br />
            <div className="alert-table-hotels-title">
                <div
                    onClick={onClose}
                    className="close-panel-circle"
                >
                    <DmpIcons.ActionsIcons.ClosePanelFillColorIcon className="close-panel-icon" />
                </div>
                <h2 style={{
                    fontSize: '20px',
                    textAlign: 'left',
                    fontWeight: 400,
                    fontFamily: 'Quincy CF, serif',
                }}>
                    Select Groups
                </h2>
            </div>
            <CustomTable
                columns={columns}
                data={groups}
                loading={loading}
                selectedRows={rowSelection}
                setSelectedRows={setRowSelection}
                uniqueId="id"
            />
        </div>
    );
};

export default GroupListTable;
